export const CPA_SECTIONS = [
  ["Calling Activity", [["Dials completed", "dials"], ["Connects", "connects"]]],
  ["Follow-up Activity", [["Follow-ups due", "followUpsDue"], ["Follow-ups completed", "followUpsCompleted"]]],
  ["Lead Activity", [["New leads added", "newLeads"]]],
  ["Deals Closed", [["Deals closed today", "dealsClosed"], ["ARR closed today", "arrClosed", "currency"]]],
  ["Demos and Meet", [["CP Meet", "demosCompletedToday"], ["CP Meeting Scheduled", "demosScheduledFuture"]]],
  ["Inbound Sales", [["Inbound sales / deals", "inboundDealsClosed"], ["Inbound ARR", "inboundArrClosed", "currency"]]]
];

export function buildDsrSubmissionPayload(role, form) {
  if (role !== "cpa") return form;
  return {
    ...Object.fromEntries(CPA_SECTIONS.flatMap(([, items]) => items.map(([, field]) => [field, form[field]]))),
    notes: form.notes || "",
    cpAssignments: (form.cpAssignments || []).map(({ assignedToId }) => ({ assignedToId }))
  };
}

export function cpAssignmentLabel(entry) {
  return entry.assignedToName || entry.assignedToId || "No agent selected";
}
